import { Injectable, Injector } from "@angular/core";
import { ServerService } from "src/services/server.service";
import { Actions } from "./enum/actions";
import { AppViewStates } from "./enum/app-view-states";
import { OperationParam } from "./enum/operation-param";
import { LoginResult } from "./enum/login-result";
import { Model } from "./model";
import { text } from 'src/services/text.service';
import { Messages, MessageTypeEnum } from "src/services/messages.service";
import { SnippetActionParam } from "./types/snippetActionParam";
import { SnippetSearchResultItem } from "./types/snippetSearchResultItem";
import { NamedValuesItem } from "./types/named-values-item";
import { SnippetsGroupsParam } from "./types/snippets-groups-item";
import { Constants } from "./constants";
import { Utilits } from "./utilits";
declare let hljs:any;

/**Действия */
@Injectable({
  providedIn: 'root'
})
export class Act {
  constructor(private model: Model
    , private messages: Messages
    , private server: ServerService
    ) {
    this.do(Actions.initApp);
  }

  /**
   * Выполнить действие
   * @param action действие
   * @param data данные
   */
  do(action: Actions, data: any = null) {
    switch (action) {
      ////Переключение состояния вида приложения
      case Actions.changeAppViewState: {
        this.model.mainViewState.set(<AppViewStates>data);
        }
        break;

      ////Неавторизованный запрос произошёл
      case Actions.unauthenticatedRequest: {
        alert('Unauthenticated Request');
        this.model.auth.set(false);
        }
        break;

      ////Инициализация приложения
      case Actions.initApp: {
        this.server.post('LoadInitialData', null).subscribe((res: any) => {
          console.log('LoadInitialData OK res = ', res);
          this.model.auth.set(true);

          if(res){
            if(res.CodeSectionConfig){
              this.model.patterns.set(JSON.parse(res.CodeSectionConfig));
              this.model.patternsArrayTextareaVal.set(Utilits.patternsTextPrepare(JSON.stringify(this.model.patterns())));
            }
            if(res.SnippetsGroups){
              this.model.snippetsGroups = JSON.parse(res.SnippetsGroups);
              // console.log('this.model.snippetsGroups',this.model.snippetsGroups);
              this.model.snippetsGroups.sort((a, b) => {
                if (a.txtValue > b.txtValue) return 1;
                if (a.txtValue < b.txtValue) return -1;
                return 0;
              });
            }
            //if(res.UserName)this.model.userName = res.UserName;
          }
          
        }, (err: any)=>{
          console.log('LoadInitialData err res', err);
          this.model.auth.set(false);
          let patternsArrayTextLocalStorage = localStorage['patternsArrayText'];
          if(patternsArrayTextLocalStorage)
          {
            this.model.patterns.set(JSON.parse(patternsArrayTextLocalStorage));
          }
          else
          {
            this.model.patterns.set(JSON.parse(Constants.patternsArrayTextDefault));
          }
          this.model.patternsArrayTextareaVal.set(Utilits.patternsTextPrepare(JSON.stringify(this.model.patterns())));
        });

        let settingsLocalStorage = localStorage['settings'];
        if(settingsLocalStorage){
          let settings = JSON.parse(settingsLocalStorage);
          this.model.helpVisible.set(settings.helpVisible);
        }
        else{
          this.model.helpVisible.set(true);
        }

        this.do(Actions.changeAppViewState, AppViewStates.code);

        this.server.post('NamedValues', {
          operation: OperationParam.Get,
          name: 'copypastePalette'
        }).subscribe((res: any)=>{
          if(res){
            // console.log('load copypastePalette', res);
            this.model.copypastePalette = JSON.parse(res.Val);
            this.model.copypastePalette = this.model.copypastePalette.filter(it => it.value!=null && it.value.length>0);          
          }
          if(this.model.copypastePalette.length == 0 
            || this.model.copypastePalette.length > 0 
                && this.model.copypastePalette[this.model.copypastePalette.length-1].value?.length > 0){
                  this.model.copypastePalette.push({value:'', isPattern: false});
                }
        });

        var copypasteTempPaletteLocalStorage = localStorage['copypasteTempPalette'];
        if(copypasteTempPaletteLocalStorage){
          this.model.copypasteTempPalette.set(JSON.parse(copypasteTempPaletteLocalStorage));
        }
        if(this.model.copypasteTempPalette().length == 0 
          || this.model.copypasteTempPalette().length > 0 
              && this.model.copypasteTempPalette()[this.model.copypasteTempPalette().length-1].value?.length > 0){
                this.model.copypasteTempPalette.update(values  => [...values, {value:''}]);
              }
        }
        break;

      ////Действие с snippetsGroups
      case Actions.snippetsGroups: {
        let snippetsGroupsActionParam: SnippetsGroupsParam = <SnippetsGroupsParam>data;

        switch(snippetsGroupsActionParam.operation){
          case OperationParam.List:
            this.server.post('LoadInitialData', null).subscribe((res: any) => {
              // console.log('SnippetsGroups LoadInitialData',res);
              if(res && res.SnippetsGroups){
                  this.model.snippetsGroups = JSON.parse(res.SnippetsGroups);
              } else {
                this.model.snippetsGroups = [];
              }
            });
          break;

          case OperationParam.Add:
          case OperationParam.Update:
          case OperationParam.Del:
            console.log('snippetsGroupsActionParam',snippetsGroupsActionParam);
            this.server.post('SnippetsGroups', snippetsGroupsActionParam).subscribe((res)=>{
                if(snippetsGroupsActionParam.operation==OperationParam.Del){
                  if(res && res=='exists'){
                    this.do(Actions.showMessage, 'В группе есть сниппеты. Удалите сниппеты перед удалением группы.');
                  }else{
                    this.do(Actions.showMessage, 'Удалено');
                    this.do(Actions.snippetsGroups, { operation: OperationParam.List });
                  }
                }else{
                  this.do(Actions.showMessage, 'Сохранено');
                  this.do(Actions.snippetsGroups, { operation: OperationParam.List });
                }
              });
          break;
        }}
        break;


      ////Действие с snippet
      case Actions.snippet: {
        let snippetActionParam: SnippetActionParam = <SnippetActionParam>data;
        switch(snippetActionParam.operation){
          case OperationParam.Add:
          case OperationParam.Update:
            this.model.saving.set(true);
            this.server.post('Snippet', {
              operation: snippetActionParam.operation,
              TxtValue: this.model.snippetEditItem.value
              , Description: this.model.snippetEditItem.description
              , Mode: this.model.snippetEditItem.mode
              , GroupId: this.model.snippetGroupVal
              , id: this.model.snippetEditItem.id
            }).subscribe(()=>{
              this.model.saving.set(false);
              this.do(Actions.showMessage, text.of('saved'))              
            });
            break;

          case OperationParam.Del:
            this.model.saving.set(true);
            this.server.post('Snippet', {
              operation: snippetActionParam.operation,
              id: snippetActionParam.snippet.Id
            }).subscribe(()=>{
              this.model.saving.set(false);
              snippetActionParam.snippet.Deleted = true;
            });
            break;
        } }
        break;


      ////Поиск snippets
      case Actions.snippetSearch: {
          this.server.post('SearchSnippet', { 
            searchText: this.model.snippetSearchVal
            , groupId: parseInt(this.model.snippetGroupVal) 
          }).subscribe(result => {
            // console.log('SearchSnippet result',result);
            this.model.snippetSearchResult = <SnippetSearchResultItem[]>result;
            this.model.snippetSearchResult.forEach((s: SnippetSearchResultItem)=>{
              if(!s.Mode){
                s.Mode = Constants.aceModeDefault;
              }
              // s.TxtValueHtml = hljs.highlight(s.TxtValueHtml, {language: 'sql'}).value;
              s.TxtValueHtml = hljs.highlight(s.TxtValue, {language: 'sql'}).value;
              s.TxtValueHtml = s.TxtValueHtml.replace(/(?:\r\n|\r|\n)/g, '<br />');
              s.TxtValueHtml = s.TxtValueHtml.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

              if(s.GroupId>0){
                let group = this.model.snippetsGroups.find((g)=>g.id==s.GroupId);
                if(group) s.GroupName = group.txtValue;
              }
            });
          }); }
          break;


        ////Сохранить конфиг CodeSection
        case Actions.codeSectionConfigSave: {
          //если паттерны не парсятся не сохраняю
          try{
            this.model.patterns.set(JSON.parse(this.model.patternsArrayTextareaVal()));
          }
          catch(ex){
            this.do(Actions.showMessage, `Текст паттернов не парсится. Настройки не сохранены. ${ex}`);
            return;
          }

          if(this.model.auth()){
            this.server.post('ConfigSave', {
              TxtValue: JSON.stringify(this.model.patterns())
            }).subscribe(()=>{
              this.do(Actions.showMessage, text.of('saved'));
            });
            }
          else
          {
            localStorage['patternsArrayText'] = JSON.stringify(this.model.patterns());
            this.do(Actions.showMessage, text.of('saved'));
          } }
          break;

        ////сохранить палитру копипаста
        case Actions.copypastePaletteSave: {
          if(this.model.copypastePalette[this.model.copypastePalette.length-1].value?.length > 0){
                  this.model.copypastePalette.push({value:'', isPattern: false});
                }

          this.do(Actions.namedValues, { operation: OperationParam.Update, name: 'copypastePalette', val: JSON.stringify(this.model.copypastePalette) });
          }
          break;

          ////сохранить временную палитру копипаста
          case Actions.copypasteTempPaletteSave: {
            this.model.copypasteTempPalette.update(values => values.filter((v)=>v?.value.length>0));
            if(this.model.copypasteTempPalette()[this.model.copypasteTempPalette().length-1].value?.length > 0){
                    this.model.copypasteTempPalette.update(values => [...values, {value:''}]);
                  }
  
            localStorage.setItem('copypasteTempPalette', JSON.stringify(this.model.copypasteTempPalette()));
            }
            break;

          ////добавить в временную палитру копипаста
          case Actions.addToCopypasteTempPalette: {
            let param: string = <string>data;
            this.model.copypasteTempPalette.update(values => [...values, {value:param}]);
            this.do(Actions.copypasteTempPaletteSave);
            }
            break;

        ////Действие с namedValues хранилище ключ-значение в бд
        case Actions.namedValues: {
          let param: NamedValuesItem = <NamedValuesItem>data;
          switch(param.operation){
            case OperationParam.Add:
            case OperationParam.Update:
              this.model.saving.set(true);
              this.server.post('NamedValues', {
                operation: param.operation,
                name: param.name
                , val: param.val
              }).subscribe(()=>{
                this.model.saving.set(false);
                this.do(Actions.showMessage, text.of('saved'))              
              });
              break;

            case OperationParam.Del:
              this.model.saving.set(true);
              this.server.post('NamedValues', {
                operation: param.operation,
                name: param.name
              }).subscribe(()=>{
                this.model.saving.set(false);
              });
              break;
          }
        }
          break;

      ////Вывод сообщения
      case Actions.showMessage: {
        this.messages.add(<string>data, MessageTypeEnum.Info);
        }
        break;

      ////сохранить настройки в localStorage
      case Actions.settingsLocalSave: {
        var settings = {
          helpVisible: this.model.helpVisible()
        };
        localStorage.setItem('settings', JSON.stringify(settings));
        }
        break;

      ////Войти
      // case Actions.login: {
      //   this.model.loginResultMessage = '';
      //   this.server.post('/api/Account/Login',  { Login: data.loginValue, Pass: data.passwordValue }, true)
      //     .subscribe((result: LoginResult) => {
      //       // console.log('auth',result);
      //       switch(result){
      //         case LoginResult.Ok:
      //           this.model.auth = true;
      //           this.do(Actions.initApp);
      //         break;
      //         default:
      //           this.model.loginResultMessage = text.of('loginResultMessageDefault');
      //         break;
      //       }
      //     }); }
      //   break;

    }
  }
}
